export default [
    {
        path: '/job-sheets/:job_sheet',
        name: 'job-sheets.show',
        component: require('../views/job-sheets/show').default
    }
]
